import LoginSSOPage from "./LoginSSOPage";

export default LoginSSOPage;
